import { FETCH_FUNCTIONAL_AREA_FILTER } from '../actions/types'

export default function (state = [], action) {
  switch (action.type) {
    case FETCH_FUNCTIONAL_AREA_FILTER:
      state = action.payload.data ? action.payload.data.functionalArea : []
      return state
  }
  return state
}
